
import React from 'react';
import { Upload } from '../types';
import { CheckIcon } from './icons';

const UploadItem: React.FC<{ upload: Upload }> = ({ upload }) => {
    const isComplete = upload.status === 'complete';
    return (
        <div className="bg-white rounded-3xl shadow-float p-5 w-80 animate-fade-in-down">
            <div className="flex items-start justify-between">
                <div className="w-full">
                    <p className="text-sm font-bold text-text-ink line-clamp-2">{upload.taskPrompt}</p>
                    <div className="text-xs font-semibold text-text-ink/70 mt-1.5">
                        {isComplete ? (
                            <span className="flex items-center gap-2 text-text-ink">
                                <div className="bg-upload-bg rounded-full p-0.5 text-text-ink">
                                    <CheckIcon className="w-3 h-3" />
                                </div>
                                <span>Upload complete!</span>
                            </span>
                        ) : (
                            `Uploading... ${upload.progress}%`
                        )}
                    </div>
                </div>
            </div>
            <div className="w-full rounded-full h-2 mt-3 overflow-hidden" style={{ backgroundColor: '#E8E4DF' }}>
                <div
                    className="h-2 rounded-full transition-all duration-300"
                    style={{ width: `${upload.progress}%`, backgroundColor: isComplete ? '#6E7A5A' : '#7BBFAF' }}
                ></div>
            </div>
        </div>
    );
}

interface UploadManagerProps {
    uploads: Upload[];
}

const UploadManager: React.FC<UploadManagerProps> = ({ uploads }) => {
    const activeUploads = uploads.filter(u => u.status === 'uploading' || u.status === 'complete');

    if (activeUploads.length === 0) {
        return null;
    }

    return (
        <div className="fixed bottom-4 right-4 z-[200] space-y-3">
            {activeUploads.map(upload => (
                <UploadItem key={upload.id} upload={upload} />
            ))}
        </div>
    );
};

export default UploadManager;
